import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    wrapper: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        padding: '30px 64px',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            display: 'block'
        }
    },
    leftPanel: {
        minWidth: 360,
        width: 360,
        paddingBottom: 50,
        backgroundColor: theme.palette.grey[50],
        position: 'relative',
        borderRight: `2px solid ${theme.palette.grey[300]}`,
        [theme.breakpoints.down('md')]: {
            width: '100%',
            borderRight: 'none',
            borderBottom: `2px solid ${theme.palette.grey[300]}`
        }
    },
    contentPanel: {
        position: 'relative',
        padding: '0 40px 40px',
        width: 'calc(100% - 360px)',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            padding: '26px 30px 40px'
        }
    }
}));
